import axios from 'src/app-axios';
import Constants from 'src/constants';

export const register = {
  namespaced: true,
  state: {
    userDetails: {},
    storedUserDetails: {},
    documentTypes: [],
    emergencyContacts: [],
  },
  getters: {
    getUserDetails (state) {
      return state.userDetails;
    },
    getStoredUserDetails (state) {
      return state.storedUserDetails;
    },
    getDocumentTypes (state) {
      return state.documentTypes;
    },
    getEmergencyContacts (state) {
      return state.emergencyContacts;
    },
  },
  mutations: {
    setUserDetails (state, data) {
      state.userDetails = data;
    },
    setStoredUserDetails (state, data) {
      state.storedUserDetails = data;
    },
    setDocumentTypes (state, data) {
      state.documentTypes = data;
    },
    clearDocumentTypes (state) {
      state.documentTypes = [];
    },
    setEmergencyContact (state, data) {
      state.emergencyContacts.push(data);
    },
  },
  actions: {
    async verifyMobileNumber ({ dispatch, commit }, payload) {
      const url = 'api/devices/app-users/mobile-verify';

      try {
        await axios.post(url, payload);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: exception.response.data.message,
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async verifyOtp ({ dispatch, commit }, payload) {
      const url = 'api/devices/app-users/otp-verify';
      try {
        const response = await axios.post(url, payload);
        commit('setUserDetails', response.data);
        return response.data;
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'OTP verification failed.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    updateUserDetails (context, details) {
      context.commit('setStoredUserDetails', details);
    },
    async fetchWorkerDocumentTypes ({ dispatch, commit }, payload) {
      const url = `api/devices/document-types/${payload.categoryId}`;
      try {
        const types = await axios.get(url);
        commit('setDocumentTypes', types.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in getting your document types list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async uploadDocumentFiles ({ dispatch }, payload) {
      const url = `api/devices/organizations/${payload.externalId}/app-users/${payload.appUserId}/upload`;
      try {
        await axios.post(url, payload.documentDetails);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in uploading your documents.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async acceptDeclaration ({ dispatch }, payload) {
      const url = `api/devices/organizations/${payload.externalId}/app-users/${payload.appUserId}/declarations`;
      try {
        await axios.post(url, payload.declarationDetails);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in completing your registration process',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async registerAppUser ({ dispatch }, payload) {
      const url = 'api/devices/sign-up';
      try {
          await axios.post(url, payload.details);
      } catch (exception) {
          dispatch('alert/onAlert', {
              message: 'Something went wrong in registering.',
              type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          throw exception;
      }
    },
    clearStoredDocumentTypes (context) {
      context.commit('clearDocumentTypes');
    },
    emergencyContacts ({ commit }, payload) {
      commit('setEmergencyContact', payload);
    },
  },
};
